import { render, staticRenderFns } from "./bodega-alta-vista.vue?vue&type=template&id=64f384ec&scoped=true"
import script from "./bodega-alta-vista.vue?vue&type=script&lang=js"
export * from "./bodega-alta-vista.vue?vue&type=script&lang=js"
import style0 from "./bodega-alta-vista.vue?vue&type=style&index=0&id=64f384ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f384ec",
  null
  
)

export default component.exports